import {estimateGenerationCredits, PLAN_LIMITS} from '@reactorbox/shared';

// Illustrative five-second clips at the current provisional app rate.
export const planImageCredits = estimateGenerationCredits('image');
export const estimatePlanImages = (credits: number): number => Math.floor(credits / planImageCredits);
export const planVideoSeconds = 5;
export const planVideoCredits = estimateGenerationCredits('video', planVideoSeconds);
export const estimatePlanVideos = (credits: number): number => Math.floor(credits / planVideoCredits);
export const displayPlanCredits = (credits: number): string => credits.toLocaleString('en-US');

// Shared server entitlements; pricing remains provisional pending provider cost validation.
export const plans = [
  {
    audience: 'For quick videos and your first stories.',
    credits: PLAN_LIMITS.starter.credits,
    features: ['Quick video creation', '3 active story projects', '5 saved character profiles', 'Media downloads'],
    name: 'Starter',
    price: PLAN_LIMITS.starter.monthlyPrice
  },
  {
    audience: 'For creators building a regular series.',
    credits: PLAN_LIMITS.creator.credits,
    features: ['Everything in Starter', '15 active story projects', '25 saved character profiles', 'Multiple takes & shot approvals', 'Project manifest export'],
    name: 'Creator',
    price: PLAN_LIMITS.creator.monthlyPrice
  },
  {
    audience: 'For independent producers managing a larger slate.',
    credits: PLAN_LIMITS.studio.credits,
    features: ['Everything in Creator', '50 active story projects', '100 saved character profiles', 'More room for parallel storylines', 'Our largest generation allowance'],
    name: 'Studio',
    price: PLAN_LIMITS.studio.monthlyPrice
  }
] as const;

export const comparisonPlanNames = ['Free', ...plans.map(({name}) => name)];

export const planComparison = [
  {feature: 'Monthly generation credits', values: ['0', ...plans.map(({credits}) => displayPlanCredits(credits))]},
  {feature: 'Seedance 2.5 videos · 5 seconds', values: ['0', ...plans.map(({credits}) => `≈ ${estimatePlanVideos(credits)}`)]},
  {feature: 'Estimated images', values: ['0', ...plans.map(({credits}) => `≈ ${estimatePlanImages(credits)}`)]},
  {feature: 'Active story projects', values: ['3', '3', '15', '50']},
  {feature: 'Saved character profiles', values: ['3', '5', '25', '100']},
  {feature: 'Story planning & storyboards', values: ['Included', 'Included', 'Included', 'Included']},
  {feature: 'Quick video generation', values: ['—', 'Included', 'Included', 'Included']},
  {feature: 'Project visual direction', values: ['Included', 'Included', 'Included', 'Included']},
  {feature: 'Media library & downloads', values: ['—', 'Included', 'Included', 'Included']},
  {feature: 'Multiple takes & shot approvals', values: ['—', '—', 'Included', 'Included']},
  {feature: 'Project manifest export', values: ['—', '—', 'Included', 'Included']},
  {feature: 'Cost estimates & credit history', values: ['Included', 'Included', 'Included', 'Included']}
] as const;
